// Set the place using the reverse geocode ID
// The reverse geocode ID is in the format "map_[lat]_[lon]_[address]"
const getPlaceFromReverseGeocode = (reverseGeocodeId: string) => {
  const [lat, lon, address] = reverseGeocodeId.replace("map_", "").split("_");

  if (!lat || !lon) {
    return null;
  }

  const parsedLat = parseFloat(lat);
  const parsedLon = parseFloat(lon);
  if (isNaN(parsedLat) || isNaN(parsedLon)) {
    return null;
  }

  let formattedAddress;
  if (address) {
    formattedAddress = decodeURIComponent(address.replace(/_/g, " "));
  }

  return {
    id: reverseGeocodeId,
    latitude: parsedLat,
    longitude: parsedLon,
    address: formattedAddress || ""
  };
};

export default getPlaceFromReverseGeocode;
